//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { IStream } from '@streams-drawer/model/IStream';
import { nameToStreamType, StreamsDrawerStreamType } from '@streams-drawer/streams-drawer-constants';

const getStreams = (state: ICuralateStore) => state.streams.streamsDrawer.streams;

export const getHasUserDefinedStreams = createSelector(
  getStreams,
  (streams: IStream[]) => {
    return streams.some((stream) => nameToStreamType(stream) !== StreamsDrawerStreamType.GALLERY_UPLOADS);
  },
);

export default getHasUserDefinedStreams;
